



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
import ExportDialog from '@/components/Views/Dashboard/Import & Export/ExportDialog.vue';
import VendorDialog from '@/components/Views/Vendor/VendorDialog.vue';
import {nil} from '@/common';
import VendorProfileDialog from '@/components/Views/Vendor/VendorProfileDialog.vue';
import {FeathersVuexFindAll} from '@/utils';
import GenericDeleteDialog from '@/components/Views/UI/GenericDeleteDialog.vue';

@Component({
    components: {
        GenericDeleteDialog, VendorProfileDialog, VendorDialog, ExportDialog, ImportDialog, PagedTable},
})
export default class Vendors extends Vue {

    @Prop({default: () => undefined})
    public customHeaders!: any[];

    @Prop({default: () => (() => {})})
    public addToQuery!: () => any;

    @Prop({default: true})
    public showControls!: boolean;

    @Prop({default: true})
    public showActions!: boolean;

    @Prop({default: true})
    public showFilters!: boolean;

    @Prop({default: true})
    public selectable!: boolean;

    @Prop({default: false})
    public clickable!: boolean;

    @Prop({default: 'Pros'})
    public title!: string;

    private tiers: any[] = [];
    private search = '';
    private selectedVendors: any[] = [];
    private vendors: any[] = [];
    private editingVendor: any = null;
    private deleteDialog = false;
    private selectedTier = null;
    private onlyShowRegistered = false;
    private headers = [
        {
            text: 'Name',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            value: 'name',
            func: (item: any) => item.fullName,
        },
        {
            text: 'Email',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            value: 'email',
            func: (item: any) => nil(item.email) ? '' : item.email,
        },
        {
            text: 'Priority',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            value: 'sortPriority',
            func: (item: any) => nil(item.sortPriority) ? '' : item.sortPriority,
        },
        {
            text: 'Tier',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            value: 'tier',
            func: (item: any) => nil(item.tierModel) ? '' : item.tierModel.name,
        },
        {
            text: 'Services',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: false,
            value: 'serviceTypes',
            func: (item: any) => nil(item.serviceTypeModels) ? '' : item.serviceTypeModels.map((x) => x.name).join(', '),
        },
        {
            text: 'Average Review',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            func(item: any) {
                if (nil(item.reviewModels, true)) { return ''; }
                const sum = item.reviewModels.map((x) => x.rating).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue;
                });
                return (sum / item.reviewModels.length).toFixed(2);
            },
        },
        {
            text: 'Travel Radius',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: true,
            value: 'desiredTravelRadius',
            func: (item: any) => item.desiredTravelRadius === item.maximumTravelRadius ? item.desiredTravelRadius : `${item.desiredTravelRadius} - ${item.maximumTravelRadius}`,
        },
        {
            text: 'Address',
            style: (item: any) => item.disabled? 'opacity:0.5' : '',
            align: 'left',
            sortable: false,
            value: 'address',
            func: (item: any) => {
                return nil(item.address) ? '' : item.address.city || '';
            },
        },

    ];

    public mounted() {
        this.initialize();
    }

    private async initialize() {
        const tiersResponse = await this.$FeathersVuex.Tier.find({});
        this.tiers = tiersResponse.data;
    }


    @Watch('selectedTier')
    private onSelectedTierChanged(value: string, oldValue: string) {
        this.refresh(true);
    }

    @Watch('search')
    private onSearchChanged(value: string, oldValue: string) {
        this.refresh(true);
    }

    @Watch('onlyShowRegistered')
    public onOnlyShowRegisteredChanged(value: boolean, oldValue: boolean) {
        this.refresh(true);
    }
    public refresh(resetState = false) {
        (this.$refs.table as any).refresh(resetState);
    }
    private get exportableVendors() {
        return this.selectedVendors.map((x) => ({
            _id: x._id,
            email: x.email,
            firstName: x.firstName,
            lastName: x.lastName,
            street: x.address.street,
            street2: x.address.street2,
            city: x.address.city,
            state: x.address.state,
            zip: x.address.zip,
            country: x.address.country,
            company: x.company,
            region: x.region,
            latitude: nil(x.location) ? '' : x.location.coordinates[1],
            longitude: nil(x.location) ? '' : x.location.coordinates[0],
            tier: nil(x.tierModel) ? '' : x.tierModel.name,
            serviceTypes: nil(x.serviceTypeModels) ? '' : x.serviceTypeModels.map((stm) => stm.name).join(', '),
            desiredTravelRadius: x.desiredTravelRadius,
            maximumTravelRadius: x.maximumTravelRadius,
            aboutMe: x.aboutMe,
        }));
    }

    private onEdit(item: any) {
        this.editingVendor = Object.assign({}, item);
        (this.$refs.vendorDialog as any).open();
    }

    private onDelete(item: any) {
        this.editingVendor = Object.assign({}, item);
        (this.$refs.deleteDialog as any).open = true;
    }
    public onDeleted() {
        this.editingVendor = null;
        (this.$refs.table as any).refresh(true);
    }
    public onCreate() {
        this.editingVendor = null;
        (this.$refs.vendorDialog as any).open();
    }

    private get searchQuery() {
        return nil(this.search) || this.search === '' ? undefined : {
            $or: [
                {firstName: {$search: this.search.toString()}},
                {lastName: {$search: this.search.toString()}},
                {email: {$search: this.search.toString()}},
            ],
        };
    }
    private async deleteRefreshBookings() {
        if (nil(this.editingVendor)) { return; }
        const {Booking} = this.$FeathersVuex;
        const assignedBookings = await FeathersVuexFindAll(Booking, {
            query: {assignedVendor: this.editingVendor._id},
        });
        const requestedBookings = await FeathersVuexFindAll(Booking, {
            query: {requestedVendor: this.editingVendor._id},
        });
        const bookings = [];
        if (assignedBookings.length > 0 ) {
            bookings.push({title: 'Assigned To These Bookings', content: assignedBookings});
        }
        if (requestedBookings.length > 0) {
            bookings.push({title: 'Requested For These Bookings', content: requestedBookings});
        }
        return bookings;
    }
    private get tierQuery() {
        return nil(this.selectedTier) ? undefined : {
            tier: this.selectedTier,
        };
    }

    private get registeredOnlyQuery() {
        return nil(this.onlyShowRegistered, true) ? undefined : {
            user: {$ne: 'null'},
        };
    }
    private onQuery() {
        return {
            ...this.searchQuery,
            ...this.tierQuery,
            ...this.registeredOnlyQuery,
            ...this.addToQuery(),
        };
    }
    private get actualHeaders() {
        return nil(this.customHeaders) ? this.headers : this.customHeaders;
    }
}
